<template>
    <v-card>
        <v-card-text class="treasure-body">
            <div v-if="isError" class="text-center">
                {{ errorMessage }}
            </div>
            <div v-else>
                <div v-if="isAlreadyRedeem" class="text-center display-1">
                    Already Redeem
                </div>
                <div v-else class="text-center subtitle-1">
                    Click redeem to redeem the reward.
                </div>
            </div>
        </v-card-text>
        <v-card-actions class="redeem-action" v-if="!isAlreadyRedeem">
            <v-btn color="primary" class="px-6" @click="redeem">Redeem</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
export default {
    name: 'RedeemTreasureView',

    props: {
        gameId: {
            type: String,
            default: null
        }
    },

    data () {
        return {
            treasureHuntGame: null,
            errorMessage: null
        }
    },

    computed: {
        isAlreadyRedeem () {
            return !!this.treasureHuntGame?.isRedeemed
        },

        isError () {
            return this.errorMessage !== null
        }
    },

    watch: {
        gameId (newValue) {
            if (!newValue) { return }

            this.fetchTreasureHuntGame(newValue)
        }
    },

    methods: {
        async fetchTreasureHuntGame (gameId) {
            let treasureHuntGame = null
            try {
                treasureHuntGame = await this.$store.dispatch('treasureHunt/getTreasureHuntGameById', { gameId })
            } catch (err) {
                this.errorMessage = err?.response?.data?.message
                return this.$app.alert(err?.response?.data?.message, err.message)
            }
            this.treasureHuntGame = treasureHuntGame
        },

        async redeem () {
            try {
                await this.$store.dispatch('treasureHunt/redeemTreasure', {
                    gameId: this.gameId
                })
            } catch (err) {
                return this.$app.alert(err?.response?.data?.message, err.message)
            }

            this.fetchTreasureHuntGame(this.gameId)
        }
    }
}
</script>

<style lang="scss" scoped>
.treasure-body {
    min-height: 300px;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.redeem-action {
    justify-content: center;
}
</style>
